import React, { useEffect, useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import Layout from "../../Components/Layout/Layout";
import CreateTicket from "./Components/Modal/CreateTicket";
import CommentModal from "./Components/Modal/CommentModal";
import Table from "./Components/Table";
import "./style.css";
import "./responsive.css";
import { useDispatch, useSelector } from "react-redux";
import { getTicketDetails, getTicketList } from "../../redux/actions/ticket";
import CloseTicket from "./Components/Modal/CloseTicket";

const ContactUs = () => {

  const dispatch = useDispatch();

  const list = useSelector(state => state.ticket.list);
  const details = useSelector(state => state.ticket.ticketDetails);
  const openTicket = list?.filter(item => item?.ticketStatus != "CLOSED");
  const closedTicket = list?.filter(item => item?.ticketStatus == "CLOSED");

  const [showComments, setShowComments] = useState(false);
  const [showCloseTicket, setShowCloseTicket] = useState(false);
  const [activeTicket, setActiveTicket] = useState({})

  useEffect(() => {
    dispatch(getTicketList());
  }, [])

  const getOldComments = (data) => {
    setShowComments(true)
    setActiveTicket(data);
    dispatch(getTicketDetails({ ticketId: data?.ticketId }))
  }

  const clostTicketModal = data => {
    if (showComments) setShowComments(false);
    setShowCloseTicket(true);
    setActiveTicket(data);
  }

  return (
    <Layout title="Contact Us" page="contact">
      <div className="contact-sec">
        <div className="top-right-btn">
          <CreateTicket />
        </div>
      </div>
      <div className="top-tab-btns contact-tabs">
        <Tabs defaultActiveKey="openTickets" id="uncontrolled-tab-example2" className="top-tab-ul contact-ul mb-3 px-4">
          <Tab eventKey="openTickets" title="Open tickets">
            <Table data={openTicket} commentModal={getOldComments} ticketModal={clostTicketModal} type="OPEN" />
          </Tab>
          <Tab eventKey="closedTickets" title="Closed tickets">
            <Table data={closedTicket} commentModal={getOldComments} ticketModal={clostTicketModal} type="CLOSED" />
          </Tab>
        </Tabs>
      </div>
      {showComments && <CommentModal show={showComments} handleClose={() => { setShowComments(false) }} data={activeTicket} comments={details} ticketModal={clostTicketModal} />}
      {showCloseTicket && <CloseTicket show={showCloseTicket} handleClose={() => { setShowCloseTicket(false) }} data={activeTicket} />}
    </Layout>
  );
};

export default ContactUs;
